import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    currentView: 'CATALOG', // Views: 'CATALOG', 'PROFILE', 'CHECKOUT', 'CONFIRMATION'
    selectedBook: null,
};

const navigationSlice = createSlice({
    name: 'navigation',
    initialState,
    reducers: {

        // Select book and navigate to profile
        openBookProfile: (state, action) => {
            state.currentView = 'PROFILE';
            state.selectedBook = action.payload;
        },

        // Return to main catalog
        returnToCatalog: (state) => {
            state.currentView = 'CATALOG';
            state.selectedBook = null;
        },

        // Open checkout screen for selected book
        openCheckout: (state) => {
            state.currentView = 'CHECKOUT';
        },

        // Complete checkout and show confirmation screen
        confirmCheckout: (state, action) => {
            state.currentView = 'CONFIRMATION';

                if (state.selectedBook) {
                state.selectedBook = {
                ...state.selectedBook,
                ...action.payload,
                isAvailable: false,
                availability: 'Checked Out',
                }
            }
        },
    },
});

export const {
    openBookProfile,
    returnToCatalog,
    openCheckout,
    confirmCheckout,
} = navigationSlice.actions;

export default navigationSlice.reducer;